import React from 'react';
import { withRouter } from 'react-router-dom';
// import cookie from 'react-cookies';
import CatalogProductCard from '../../../ProductCatalog/Components/CatalogProductCard';
import { parseQuery, __ } from '../../../../Utils';
import { connect, actions } from '../../../../Store';
import BaseList from '../../BaseList';
import API2 from '../../../../API2';

class Catalog extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Produktový katalóg'),
      notFoundMessage: __('Ľutujeme produkty sa nenašli '),
      isProduct: true,
      cartItemsIds: [],
      maxFilterWidth: 144,
      cartItems: [],
    };

    actions.setActiveMenuItem('44');
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.init();
    }
  }

  componentDidMount() {
    this.init();
  }

  init() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
      searchText,
      scrollPosition,
    } = this.loadActualData();

    const query = parseQuery(this.props.location.search);

    const newSearchText =
      searchText &&
      searchText !== null &&
      searchText !== 'null' &&
      searchText !== 'undefined'
        ? searchText
        :  query ? query.q : '';

    let newCheckedFilter =
      checkedFilter && checkedFilter !== 'undefined'
        ? JSON.parse(checkedFilter)
        : [];

    if (query && query.campaignId) {
      newCheckedFilter.push({
        id: 'campaign',
        values: [query.campaignId],
      });
    }

    if (
      newCheckedFilter.find(n => n.id === 'type') &&
      newCheckedFilter.find(n => n.id === 'type').values &&
      (newCheckedFilter.find(n => n.id === 'type').values.indexOf('položka') >
        -1 ||
        newCheckedFilter
          .find(n => n.id === 'type')
          .values.indexOf('NATEROVY_SYSTEM') > -1)
    ) {
      // nie velmi pekne riesenie ale odstranit to problem
      newCheckedFilter = [];
    }
    this.setState(
      {
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        searchText: newSearchText,
        defaultSearchText: newSearchText,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: newCheckedFilter,
      },
      async () => {
        this.fetchFilter(!checkedFilter || checkedFilter.length === 0);
        // await this.fetchCartProducts();
        await this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });
        window.scrollTo({
          top: scrollPosition ? Number(scrollPosition) : 0,
        });
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  // async fetchCartProducts() {
  //   try {
  //     const activeCard = cookie.load('cart');
  //     if (activeCard) {
  //       const r = await API2.getCartAction(activeCard);
  //       this.setState({
  //         cartItems: r.items,
  //         cartItemsIds: r.items.map(item => {
  //           return item.product_id;
  //         }),
  //       });
  //     }
  //   } catch (e) {
  //     this.setState({ error: __('Nepodarilo sa načítať produkty v košíku') });
  //   }
  // }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText } = this.state;

    try {
      const params = parameters;

      if (checkedFilter) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      if (this.props.location.pathname === '/buy/sales') {
        params.categoryName = 'vypredaj';
      }

      const newData = await API2.getUltraLiteB2BCatalogProductsAction(
        Object.assign(params, { limit }),
      );

      this.fetchFullData(Object.assign(params, { limit }));

      this.setState({
        items: newData.products,
        loading: false,
        variantLoading: true,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchFullData(params) {
    const newFullData = await API2.getB2BCatalogProductsAction(params);

    this.setState({
      items: newFullData.products,
      variantLoading: false,
    });
  }

  updateCartItems(cartItems) {
    this.setState({
      cartItems,
      cartItemsIds: cartItems.map(item => {
        return item.product_id;
      }),
    });
  }

  openProduct(id) {
    this.props.history.push(`/catalog/list/${id}`);
  }

  renderItemsList() {
    const { items, cartItems, cartItemsIds, variantLoading } = this.state;
    const { carts } = this.props;

    return (
      // <ListOfProducts>
      items.map(p => {
        return (
          <CatalogProductCard
            appLang={this.props.appLang}
            role={this.props.user.role}
            location={this.props.location}
            history={this.props.history}
            settings={this.props.settings}
            key={p._id}
            onProductClick={() => this.openProduct(p._id)}
            productLink={`/catalog/list/${p._id}`}
            updateCartItems={i => this.updateCartItems(i)}
            firm={this.props.user.firm}
            data={p}
            cartItems={cartItems}
            cartItemsIds={cartItemsIds}
            carts={carts}
            variantLoading={variantLoading}
            customerId={this.props.user.customer_id}
          />
        );
      })
      // </ListOfProducts>
    );
  }

  render() {
    return super.render();
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default withRouter(connect(mapStateToProps)(Catalog));



// WEBPACK FOOTER //
// ./src/Containers/Buy/Catalog/List/index.jsx